import styled from 'styled-components';
import {Stack as UltraStack, Item as UltraItem} from 'components/ultra';

export const LogoLink = styled.a`
  background: ${({theme}) => theme.color.white};
  display: inline-block;
  width: 24rem;
  padding: 4rem 2rem;
  margin-right: 3.2rem;

  &:hover {
    img {
      transform: scale(1.1);
    }
  }

  img {
    width: 100%;
    transition: transform 0.2s ease-out;
  }
`;

export const Stack = styled(UltraStack)`
  margin-top: 1.6rem;
`;

export const Item = styled(UltraItem)`
  flex: 0 1 auto;
`;
